import { sanitizeHtml } from "../../sanitizeHtml";
/* ──────────────────────────────────────────────────────────────────────────
   PolicyModal — shared Privacy Policy / Terms popup used by the course-landing
   templates. Self-contained inline styles so it needs no per-template CSS and
   renders consistently regardless of the surrounding scope.

   Props:
     open     "privacy" | "terms" | null
     policies { privacy, terms, privacy_subject, terms_subject }
     onClose  () => void
   ────────────────────────────────────────────────────────────────────────── */
export default function PolicyModal({ open, policies = {}, onClose }) {
  if (!open) return null;
  const title =
    open === "privacy"
      ? policies.privacy_subject || "Privacy Policy"
      : policies.terms_subject || "Terms";
  const html = open === "privacy" ? policies.privacy : policies.terms;

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 10000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "1rem",
        background: "rgba(13,17,23,.6)",
        backdropFilter: "blur(4px)",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff",
          width: "100%",
          maxWidth: "680px",
          maxHeight: "88vh",
          borderRadius: "16px",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          boxShadow: "0 20px 60px rgba(0,0,0,.25)",
          fontFamily:
            "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "1.1rem 1.4rem",
            borderBottom: "1px solid #e1e4e8",
          }}
        >
          <h3 style={{ fontSize: "1.05rem", fontWeight: 800, color: "#0d1117", margin: 0 }}>
            {title}
          </h3>
          <button
            type="button"
            aria-label="Close"
            onClick={onClose}
            style={{
              background: "transparent",
              border: "none",
              cursor: "pointer",
              fontSize: "1.6rem",
              lineHeight: 1,
              color: "#6e7681",
            }}
          >
            ×
          </button>
        </div>
        <div
          style={{
            padding: "1.4rem",
            overflowY: "auto",
            fontSize: ".9rem",
            color: "#3b4552",
            lineHeight: 1.8,
          }}
          dangerouslySetInnerHTML={{ __html: sanitizeHtml(html || "") }}
        />
      </div>
    </div>
  );
}
